import React, { Component } from 'react';
import _ from 'lodash';
import RadioButton from '../../../../../components/ZUILib/RadioButton';
import SelectionTab from '../../../../../components/ZUILib/SelectionTab';
import Image from '../../../../../components/ZUILib/Image';
import commonUtil from '../../../../../utils/commonUtil';
import { getOpeningOrClosingGiftForEvent, getEventDeliveryAddresses } from '../../actions';

const defaultGiftImage = commonUtil.getAssetURL() + '/images/guest/gift.png';

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
export default class ClosingGift extends Component {
  constructor(props) {
    super(props);
    this.eventId = this.props.eventId;
    // this.eventId = '50002826';
    this.state = {
      closingGiftDetailsData: null,
      deliveryAddressInfo: null,
      selectedRadioAddressPreferenceValue: 'store',
    };
    this.selectedDropdownAddressInfoValue = '';
    this.selectedDropdownAddressInfoName = '';
    this.giftDeliveryAddressPreference = [
      { name: 'Entrega en tienda', code: 'store' },
    ];
    this.skus = [];
    this.giftNames = '';
  }
  UNSAFE_componentWillMount() {
    // getOpeningOrClosingGiftForEvent(this.eventId)
    //   .then((res) => {
    //     if (res.body.status.status === 'success') {
    //       this.setState({ closingGiftDetailsData: res.body.openingGiftDetailsForEventInfo });
    //     }
    //   });
    if (this.props.userEventThresholdGiftDetails?.data?.giftInfo) {
      const info = this.props.userEventThresholdGiftDetails?.data?.giftInfo || null;
      this.setState({ closingGiftDetailsData: info });
    }
    
    getEventDeliveryAddresses(this.eventId)
      .then((res) => {
        if (res.body.status.status === 'success') {
          this.setState({ deliveryAddressInfo: res.body.deliveryAddressInfo });
        }
      });
  }

  handleRadioSelected = (data, e) => {
    this.setState({ selectedRadioAddressPreferenceValue: e.target.value });
    this.selectedDropdownAddressInfoValue = '';
  }

  onAddressInfoSelectChange = (data, e) => {
    this.selectedDropdownAddressInfoValue = e.target.value;
    this.selectedDropdownAddressInfoName = e.target.options[e.target.options.selectedIndex].innerText;
  }
  getFormData = () => {
    let reqParams = {
      selectedStoreOption: this.state.selectedRadioAddressPreferenceValue === 'store' ? 'true' : 'false',
      skus: this.skus,
      gifts: this.gifts,
      selectedAddressId: null,
      selectedAddressName: null,
    };
    if (this.state.selectedRadioAddressPreferenceValue === 'home') {
      reqParams = {
        ...reqParams,
        selectedAddressId: this.selectedDropdownAddressInfoValue,
        selectedAddressName: this.selectedDropdownAddressInfoName,
      };
    }
    return reqParams;
  }
  render() {
    const { closingGiftDetailsData, deliveryAddressInfo } = this.state;
    const deliveryAddressInfoDropdown = {
      id: 'giftDeliveryAddressDropdown',
      optionText: 'labelResourceId',
      optionValue: 'value',
      options: [],
    };

    if (deliveryAddressInfo && deliveryAddressInfo.addresses) {
      deliveryAddressInfo.addresses.forEach((address) => {
        deliveryAddressInfoDropdown.options.push({
          value: address.addressId,
          labelResourceId: address.nickname,
        });
      });
      if (deliveryAddressInfo.addresses.length) {
        this.selectedDropdownAddressInfoValue = deliveryAddressInfo.addresses[0].addressId;
        this.selectedDropdownAddressInfoName = deliveryAddressInfo.addresses[0].nickname;
      }
    }

    if (closingGiftDetailsData && closingGiftDetailsData.skuInfo) {
      this.skus = [];
      this.gifts = [];
      closingGiftDetailsData.skuInfo.forEach((gift) => {
        this.skus.push(gift.skuId);
        this.gifts.push({ skuName: gift.skuName, skuImage: gift.skuImage ? gift.skuImage : '', skuId: gift.skuId });
      });
    }

    const getImageAttr = (imgURL, index) => {
      const imageAttr = {
        id: 'closingGiftRow' + index,
        src: imgURL,
        alt: '',
        altImg: defaultGiftImage,
        className: 'closingGiftImg',
      };
      return imageAttr;
    };

    return (
      <div id="giftListOption2">
        {channel === constChannels.WAP ?
          <div className="row">
            <div className="col-xs-12 innerOptions giftBlock" style={{ marginTop: '25px', padding: '0 10px' }}>
              <p style={{ fontSize: '22px', fontWeight: '400', color: '#333333' }}>
                {commonUtil.getLabel(this.props.lables.editEventClosingGift, 'eventManagement.closingGift.title')}
              </p>
              <p><span style={{ color: '#333333' }}>{commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.closingGift.message')}</span></p>
              {!_.isEmpty(this.gifts) ? <div>
                {this.gifts.map((gift, index) => (
                  <div className="mt10"><Image imageAttr={getImageAttr(gift.skuImage, index)} imgWidth={'30px'} /> {gift.skuName}</div>),
                )}
              </div> : null}
            </div>
            {this.giftDeliveryAddressPreference.map((option, index) => (
              <div className="col-xs-12" key={index}>
                <RadioButton checked={this.state.selectedRadioAddressPreferenceValue === option.code} displayName={option.name} id={'radio_giftDeliveryAddressPreference_' + option.code} value={option.code} name="giftDeliveryAddressPreferences" radioCssClass={'radio radioDF'} onChangeFunction={this.handleRadioSelected} />
                {option.code === 'home' && this.state.selectedRadioAddressPreferenceValue === 'home' ?
                  <div className="col-xs-12">
                    <div className="contentInfo infoActive" style={{ display: 'block' }}>
                      <div className="innerInfo noBorders">
                        <p>Asigna dirección de envío&nbsp;
                        <i className="iClass icon-ayuda tooltip-container">
                          <span className="tooltip-box dir-right">
                            {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.closingGift.tooltip1')}</span>
                        </i>
                        </p>
                        <SelectionTab
                          classname="cSelect required"
                          id={deliveryAddressInfoDropdown.id}
                          options={deliveryAddressInfoDropdown.options}
                          optionCaption={deliveryAddressInfoDropdown.optionCaption}
                          optionText={deliveryAddressInfoDropdown.optionText}
                          optionValue={deliveryAddressInfoDropdown.optionValue}
                          handleSelectedOption={this.onAddressInfoSelectChange}
                        />
                      </div>
                    </div>
                  </div>
                  : null}
              </div>
            ))}
          </div>
          :
          <div>
            <div className="mt10" style={{ lineHeight: '35px', paddingTop: '20px', paddingLeft: '10px' }}>
              <h3>{commonUtil.getLabel(this.props.lables.editEventClosingGift, 'eventManagement.closingGift.title')}</h3>
              <p style={{ color: '#333333' }}> {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.closingGift.message')}</p>
            </div>
            {!_.isEmpty(this.gifts) ?
              <React.Fragment>
                <div className="articleName" style={{ paddingLeft: '10px' }}>
                  {this.gifts.map((gift, index) => (
                    <div className="mt10"><Image imageAttr={getImageAttr(gift.skuImage, index)} /> {gift.skuName}</div>),
                )}
                </div>
                <RadioButton
                  checked
                  displayName="Entrega en tienda"
                  id="entregaTienda"
                  name="entregaTienda"
                  radioCssClass={'radio selectCard radioDF'}
                  style={{ color: '#333333', marginLeft: '3%' }}
                />
              </React.Fragment>
              : null}
            <div className="row" id="blockAccount">
              {this.giftDeliveryAddressPreference.map((option, index) => (
                <div className="col-xs-7" key={index}>
                  <RadioButton checked={this.state.selectedRadioAddressPreferenceValue === option.code} displayName={option.name} id={'radio_giftDeliveryAddressPreference_' + option.code} value={option.code} name="giftDeliveryAddressPreferences" radioCssClass={'radio radioDF'} onChangeFunction={this.handleRadioSelected} />
                  {option.code === 'home' && this.state.selectedRadioAddressPreferenceValue === 'home' ?
                    <div className="col-xs-7">
                      <span className="titleForm">Asignar dirección de envío&nbsp;
                      <i className="iClass icon-ayuda tooltip-container">
                        <span className="tooltip-box">
                          {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.closingGift.tooltip1')}</span>
                      </i>
                      </span>
                      <SelectionTab
                        classname="cSelect required"
                        id={deliveryAddressInfoDropdown.id}
                        options={deliveryAddressInfoDropdown.options}
                        optionCaption={deliveryAddressInfoDropdown.optionCaption}
                        optionText={deliveryAddressInfoDropdown.optionText}
                        optionValue={deliveryAddressInfoDropdown.optionValue}
                        handleSelectedOption={this.onAddressInfoSelectChange}
                      />
                    </div>
                    : null}
                </div>
              ))}
            </div>
          </div>}
      </div>
    );
  }
}
